import {type User, ApiClient} from '@hconnect/apiclient'
import type {PlantHierarchyNode} from '@hproduce/suite-core'

import {
  getFeaturesUrl,
  getMenusUrl,
  postSelectPersonaUrl,
  getPersonaUrl,
  getActivePersonaUrl,
  getPlantHierarchyUrl,
  getUserUrl
} from './constants'
import {FeatureCatalogItem, FeaturesMenu, UpdateMenuInputModel} from './types/featuresMenu'
import {Persona} from './types/personas'

export const getLoginState = () => ApiClient.loginFlow.getLoginState()

export const startLogoutProcess = () => ApiClient.loginFlow.startLogoutProcess()

export const getUser = (userId: string) => ApiClient.axiosInstance.get<User>(getUserUrl(userId))

export const getFeaturesMenu = (upmId?: string) =>
  ApiClient.axiosInstance.get<FeaturesMenu>(getMenusUrl(upmId))

export const getFeatures = (upmId?: string) =>
  ApiClient.axiosInstance.get<FeatureCatalogItem[]>(getFeaturesUrl(upmId))

export const updateFeaturesMenu = (menuItems: UpdateMenuInputModel[]) =>
  ApiClient.axiosInstance.put<void>(getMenusUrl(), menuItems)

export const getPlantHierarchy = () =>
  ApiClient.axiosInstance.get<PlantHierarchyNode[]>(getPlantHierarchyUrl())

export const getPersonas = () => ApiClient.axiosInstance.get<Persona[]>(getPersonaUrl())

export const getActivePersona = () => ApiClient.axiosInstance.get<Persona>(getActivePersonaUrl())

export const selectPersona = (personaId: number) =>
  ApiClient.axiosInstance.post(postSelectPersonaUrl(), {
    presetId: personaId
  })
